import { j as o } from "../../jsx-runtime-B6kdoens.js";
import { a as l } from "../../index-CROKJrb5.js";
import { c, f } from "../../create-component-CBAeEoQ6.js";
import { u, T as x } from "../../TooltipContext-BDAX-u97.js";
const C = c(
  "Tooltip",
  f(
    ({ as: t, children: r, className: e, options: s, tooltipType: i = "default", ...a }, p) => {
      const m = t || "div", n = u(s, i);
      return /* @__PURE__ */ o.jsx(
        m,
        {
          ref: p,
          className: l("cur-relative", e),
          ...a,
          children: /* @__PURE__ */ o.jsx(x.Provider, { value: n, children: r })
        }
      );
    }
  )
);
export {
  C as Tooltip
};
//# sourceMappingURL=index.js.map
